import { MfMonthlyItem, MfDailyItem } from '../types';

/**
 * Verified AMFI Monthly Flow & SIP Trajectory Dataset (2020 – 2026)
 * Source: Association of Mutual Funds in India (AMFI) Official Disclosures
 */
export const SEED_MF_MONTHLY_DATA: MfMonthlyItem[] = [
  // ── 2020 (Covid Crash & Recovery) ──
  {
    year: 2020, month: 1, monthName: 'Jan', monthKey: '2020-01',
    sipInflowCr: 8532, netEquityInflowCr: 7877, netDebtInflowCr: 109150, netHybridInflowCr: 1250, totalIndustryAumLakhCr: 27.85, activeSipAccountsLakh: 304,
    categories: { smallCap: 1120, midCap: 1780, largeCap: 1450, flexiCap: 1890, sectoralThematic: 920, elss: 717, otherEquity: 0 }
  },
  {
    year: 2020, month: 2, monthName: 'Feb', monthKey: '2020-02',
    sipInflowCr: 8513, netEquityInflowCr: 10796, netDebtInflowCr: -27939, netHybridInflowCr: 1980, totalIndustryAumLakhCr: 27.23, activeSipAccountsLakh: 309,
    categories: { smallCap: 1490, midCap: 2150, largeCap: 2310, flexiCap: 2540, sectoralThematic: 1100, elss: 1206, otherEquity: 0 }
  },
  {
    year: 2020, month: 3, monthName: 'Mar', monthKey: '2020-03',
    sipInflowCr: 8641, netEquityInflowCr: 11723, netDebtInflowCr: -194553, netHybridInflowCr: -3200, totalIndustryAumLakhCr: 22.26, activeSipAccountsLakh: 312,
    categories: { smallCap: 1280, midCap: 2340, largeCap: 2980, flexiCap: 2780, sectoralThematic: 780, elss: 1563, otherEquity: 0 }
  },
  {
    year: 2020, month: 4, monthName: 'Apr', monthKey: '2020-04',
    sipInflowCr: 8376, netEquityInflowCr: 6213, netDebtInflowCr: 43431, netHybridInflowCr: 1450, totalIndustryAumLakhCr: 23.93, activeSipAccountsLakh: 314,
    categories: { smallCap: 890, midCap: 1240, largeCap: 1560, flexiCap: 1670, sectoralThematic: 450, elss: 403, otherEquity: 0 }
  },
  {
    year: 2020, month: 5, monthName: 'May', monthKey: '2020-05',
    sipInflowCr: 8123, netEquityInflowCr: 5256, netDebtInflowCr: 63665, netHybridInflowCr: -1100, totalIndustryAumLakhCr: 24.54, activeSipAccountsLakh: 316,
    categories: { smallCap: 780, midCap: 1020, largeCap: 1240, flexiCap: 1420, sectoralThematic: 420, elss: 376, otherEquity: 0 }
  },
  {
    year: 2020, month: 6, monthName: 'Jun', monthKey: '2020-06',
    sipInflowCr: 7927, netEquityInflowCr: 240, netDebtInflowCr: 2862, netHybridInflowCr: -890, totalIndustryAumLakhCr: 25.49, activeSipAccountsLakh: 323,
    categories: { smallCap: 210, midCap: 350, largeCap: -210, flexiCap: 120, sectoralThematic: -120, elss: -110, otherEquity: 0 }
  },
  {
    year: 2020, month: 7, monthName: 'Jul', monthKey: '2020-07',
    sipInflowCr: 7831, netEquityInflowCr: -2480, netDebtInflowCr: 91392, netHybridInflowCr: -1450, totalIndustryAumLakhCr: 27.12, activeSipAccountsLakh: 327,
    categories: { smallCap: -580, midCap: -420, largeCap: -1050, flexiCap: -320, sectoralThematic: 180, elss: -290, otherEquity: 0 }
  },
  {
    year: 2020, month: 8, monthName: 'Aug', monthKey: '2020-08',
    sipInflowCr: 7792, netEquityInflowCr: -4000, netDebtInflowCr: -3907, netHybridInflowCr: -1890, totalIndustryAumLakhCr: 27.49, activeSipAccountsLakh: 330,
    categories: { smallCap: -780, midCap: -690, largeCap: -1540, flexiCap: -820, sectoralThematic: 210, elss: -380, otherEquity: 0 }
  },
  {
    year: 2020, month: 9, monthName: 'Sep', monthKey: '2020-09',
    sipInflowCr: 7788, netEquityInflowCr: -734, netDebtInflowCr: -51904, netHybridInflowCr: -1200, totalIndustryAumLakhCr: 26.86, activeSipAccountsLakh: 334,
    categories: { smallCap: -230, midCap: -190, largeCap: -450, flexiCap: -120, sectoralThematic: 420, elss: -164, otherEquity: 0 }
  },
  {
    year: 2020, month: 10, monthName: 'Oct', monthKey: '2020-10',
    sipInflowCr: 7800, netEquityInflowCr: -2725, netDebtInflowCr: 110469, netHybridInflowCr: -1680, totalIndustryAumLakhCr: 28.23, activeSipAccountsLakh: 337,
    categories: { smallCap: -420, midCap: -380, largeCap: -1240, flexiCap: -590, sectoralThematic: 180, elss: -275, otherEquity: 0 }
  },
  {
    year: 2020, month: 11, monthName: 'Nov', monthKey: '2020-11',
    sipInflowCr: 7302, netEquityInflowCr: -12917, netDebtInflowCr: 44984, netHybridInflowCr: -2890, totalIndustryAumLakhCr: 30.01, activeSipAccountsLakh: 341,
    categories: { smallCap: -1890, midCap: -2120, largeCap: -4890, flexiCap: -2840, sectoralThematic: -450, elss: -727, otherEquity: 0 }
  },
  {
    year: 2020, month: 12, monthName: 'Dec', monthKey: '2020-12',
    sipInflowCr: 8418, netEquityInflowCr: -10147, netDebtInflowCr: -13862, netHybridInflowCr: -2100, totalIndustryAumLakhCr: 31.02, activeSipAccountsLakh: 347,
    categories: { smallCap: -1450, midCap: -1680, largeCap: -3890, flexiCap: -2240, sectoralThematic: -210, elss: -677, otherEquity: 0 }
  },

  // ── 2021 (The Historic Retail Equitization Wave) ──
  {
    year: 2021, month: 1, monthName: 'Jan', monthKey: '2021-01',
    sipInflowCr: 8023, netEquityInflowCr: -9253, netDebtInflowCr: -33409, netHybridInflowCr: 2140, totalIndustryAumLakhCr: 30.50, activeSipAccountsLakh: 355,
    categories: { smallCap: -1240, midCap: -1540, largeCap: -3560, flexiCap: -2110, sectoralThematic: -210, elss: -593, otherEquity: 0 }
  },
  {
    year: 2021, month: 2, monthName: 'Feb', monthKey: '2021-02',
    sipInflowCr: 7528, netEquityInflowCr: -4534, netDebtInflowCr: 1735, netHybridInflowCr: 4700, totalIndustryAumLakhCr: 31.64, activeSipAccountsLakh: 363,
    categories: { smallCap: -520, midCap: -780, largeCap: -1890, flexiCap: -1120, sectoralThematic: 180, elss: -404, otherEquity: 0 }
  },
  {
    year: 2021, month: 3, monthName: 'Mar', monthKey: '2021-03',
    sipInflowCr: 9182, netEquityInflowCr: 9115, netDebtInflowCr: -52528, netHybridInflowCr: 6200, totalIndustryAumLakhCr: 31.43, activeSipAccountsLakh: 372,
    categories: { smallCap: 1240, midCap: 1560, largeCap: 2140, flexiCap: 2340, sectoralThematic: 980, elss: 855, otherEquity: 0 }
  },
  {
    year: 2021, month: 4, monthName: 'Apr', monthKey: '2021-04',
    sipInflowCr: 8590, netEquityInflowCr: 3437, netDebtInflowCr: 100987, netHybridInflowCr: 8640, totalIndustryAumLakhCr: 32.38, activeSipAccountsLakh: 380,
    categories: { smallCap: 450, midCap: 670, largeCap: 890, flexiCap: 940, sectoralThematic: 320, elss: 167, otherEquity: 0 }
  },
  {
    year: 2021, month: 5, monthName: 'May', monthKey: '2021-05',
    sipInflowCr: 8819, netEquityInflowCr: 10083, netDebtInflowCr: -44074, netHybridInflowCr: 6210, totalIndustryAumLakhCr: 33.06, activeSipAccountsLakh: 388,
    categories: { smallCap: 1240, midCap: 1890, largeCap: 2450, flexiCap: 2840, sectoralThematic: 1120, elss: 543, otherEquity: 0 }
  },
  {
    year: 2021, month: 6, monthName: 'Jun', monthKey: '2021-06',
    sipInflowCr: 9127, netEquityInflowCr: 5988, netDebtInflowCr: 3564, netHybridInflowCr: 12360, totalIndustryAumLakhCr: 33.67, activeSipAccountsLakh: 398,
    categories: { smallCap: 780, midCap: 1240, largeCap: 1450, flexiCap: 1670, sectoralThematic: 520, elss: 328, otherEquity: 0 }
  },
  {
    year: 2021, month: 7, monthName: 'Jul', monthKey: '2021-07',
    sipInflowCr: 9609, netEquityInflowCr: 22583, netDebtInflowCr: 73964, netHybridInflowCr: 19480, totalIndustryAumLakhCr: 35.32, activeSipAccountsLakh: 417,
    categories: { smallCap: 2450, midCap: 3890, largeCap: 4210, flexiCap: 8920, sectoralThematic: 2120, elss: 993, otherEquity: 0 }
  },
  {
    year: 2021, month: 8, monthName: 'Aug', monthKey: '2021-08',
    sipInflowCr: 9923, netEquityInflowCr: 8667, netDebtInflowCr: 1074, netHybridInflowCr: 18700, totalIndustryAumLakhCr: 36.59, activeSipAccountsLakh: 432,
    categories: { smallCap: 1280, midCap: 1690, largeCap: 2110, flexiCap: 2450, sectoralThematic: 720, elss: 417, otherEquity: 0 }
  },
  {
    year: 2021, month: 9, monthName: 'Sep', monthKey: '2021-09',
    sipInflowCr: 10351, netEquityInflowCr: 8677, netDebtInflowCr: -63910, netHybridInflowCr: 17870, totalIndustryAumLakhCr: 36.74, activeSipAccountsLakh: 449,
    categories: { smallCap: 1340, midCap: 1720, largeCap: 2140, flexiCap: 2490, sectoralThematic: 610, elss: 377, otherEquity: 0 }
  },
  {
    year: 2021, month: 10, monthName: 'Oct', monthKey: '2021-10',
    sipInflowCr: 10519, netEquityInflowCr: 5215, netDebtInflowCr: 12906, netHybridInflowCr: 10420, totalIndustryAumLakhCr: 37.33, activeSipAccountsLakh: 464,
    categories: { smallCap: 890, midCap: 1120, largeCap: 1340, flexiCap: 1420, sectoralThematic: 280, elss: 165, otherEquity: 0 }
  },
  {
    year: 2021, month: 11, monthName: 'Nov', monthKey: '2021-11',
    sipInflowCr: 11005, netEquityInflowCr: 11615, netDebtInflowCr: 14892, netHybridInflowCr: 9470, totalIndustryAumLakhCr: 37.34, activeSipAccountsLakh: 478,
    categories: { smallCap: 1680, midCap: 2140, largeCap: 2890, flexiCap: 3410, sectoralThematic: 980, elss: 515, otherEquity: 0 }
  },
  {
    year: 2021, month: 12, monthName: 'Dec', monthKey: '2021-12',
    sipInflowCr: 11305, netEquityInflowCr: 25077, netDebtInflowCr: -49154, netHybridInflowCr: 14870, totalIndustryAumLakhCr: 37.73, activeSipAccountsLakh: 491,
    categories: { smallCap: 3450, midCap: 4120, largeCap: 5890, flexiCap: 8120, sectoralThematic: 2410, elss: 1087, otherEquity: 0 }
  },

  // ── 2022 (FII Selling Absorbed by Domestic SIP Fortress) ──
  {
    year: 2022, month: 1, monthName: 'Jan', monthKey: '2022-01',
    sipInflowCr: 11517, netEquityInflowCr: 14888, netDebtInflowCr: 5087, netHybridInflowCr: 6230, totalIndustryAumLakhCr: 38.01, activeSipAccountsLakh: 505,
    categories: { smallCap: 2140, midCap: 2890, largeCap: 3890, flexiCap: 4120, sectoralThematic: 1240, elss: 608, otherEquity: 0 }
  },
  {
    year: 2022, month: 2, monthName: 'Feb', monthKey: '2022-02',
    sipInflowCr: 11438, netEquityInflowCr: 19705, netDebtInflowCr: -8274, netHybridInflowCr: 8470, totalIndustryAumLakhCr: 37.56, activeSipAccountsLakh: 517,
    categories: { smallCap: 2840, midCap: 3450, largeCap: 4890, flexiCap: 5670, sectoralThematic: 1890, elss: 965, otherEquity: 0 }
  },
  {
    year: 2022, month: 3, monthName: 'Mar', monthKey: '2022-03',
    sipInflowCr: 12328, netEquityInflowCr: 28463, netDebtInflowCr: -115248, netHybridInflowCr: 12890, totalIndustryAumLakhCr: 37.57, activeSipAccountsLakh: 528,
    categories: { smallCap: 3890, midCap: 4560, largeCap: 6890, flexiCap: 8740, sectoralThematic: 2890, elss: 1493, otherEquity: 0 }
  },
  {
    year: 2022, month: 4, monthName: 'Apr', monthKey: '2022-04',
    sipInflowCr: 11863, netEquityInflowCr: 15890, netDebtInflowCr: 54752, netHybridInflowCr: 7240, totalIndustryAumLakhCr: 38.04, activeSipAccountsLakh: 539,
    categories: { smallCap: 2240, midCap: 2890, largeCap: 3980, flexiCap: 4560, sectoralThematic: 1450, elss: 770, otherEquity: 0 }
  },
  {
    year: 2022, month: 5, monthName: 'May', monthKey: '2022-05',
    sipInflowCr: 12286, netEquityInflowCr: 18529, netDebtInflowCr: -32722, netHybridInflowCr: 5120, totalIndustryAumLakhCr: 37.22, activeSipAccountsLakh: 548,
    categories: { smallCap: 2680, midCap: 3240, largeCap: 4560, flexiCap: 5420, sectoralThematic: 1890, elss: 739, otherEquity: 0 }
  },
  {
    year: 2022, month: 6, monthName: 'Jun', monthKey: '2022-06',
    sipInflowCr: 12276, netEquityInflowCr: 15498, netDebtInflowCr: -92247, netHybridInflowCr: 3280, totalIndustryAumLakhCr: 35.64, activeSipAccountsLakh: 555,
    categories: { smallCap: 2190, midCap: 2840, largeCap: 3890, flexiCap: 4560, sectoralThematic: 1420, elss: 598, otherEquity: 0 }
  },
  {
    year: 2022, month: 7, monthName: 'Jul', monthKey: '2022-07',
    sipInflowCr: 12140, netEquityInflowCr: 8898, netDebtInflowCr: 4930, netHybridInflowCr: 4120, totalIndustryAumLakhCr: 37.75, activeSipAccountsLakh: 562,
    categories: { smallCap: 1450, midCap: 1780, largeCap: 2140, flexiCap: 2450, sectoralThematic: 720, elss: 358, otherEquity: 0 }
  },
  {
    year: 2022, month: 8, monthName: 'Aug', monthKey: '2022-08',
    sipInflowCr: 12693, netEquityInflowCr: 6120, netDebtInflowCr: 49164, netHybridInflowCr: 6240, totalIndustryAumLakhCr: 39.34, activeSipAccountsLakh: 572,
    categories: { smallCap: 1120, midCap: 1340, largeCap: 1480, flexiCap: 1560, sectoralThematic: 410, elss: 210, otherEquity: 0 }
  },
  {
    year: 2022, month: 9, monthName: 'Sep', monthKey: '2022-09',
    sipInflowCr: 12976, netEquityInflowCr: 14100, netDebtInflowCr: -65372, netHybridInflowCr: 3890, totalIndustryAumLakhCr: 39.88, activeSipAccountsLakh: 584,
    categories: { smallCap: 2150, midCap: 2680, largeCap: 3410, flexiCap: 4120, sectoralThematic: 1240, elss: 500, otherEquity: 0 }
  },
  {
    year: 2022, month: 10, monthName: 'Oct', monthKey: '2022-10',
    sipInflowCr: 13040, netEquityInflowCr: 9390, netDebtInflowCr: -2818, netHybridInflowCr: 4210, totalIndustryAumLakhCr: 39.50, activeSipAccountsLakh: 593,
    categories: { smallCap: 1560, midCap: 1890, largeCap: 2140, flexiCap: 2680, sectoralThematic: 780, elss: 340, otherEquity: 0 }
  },
  {
    year: 2022, month: 11, monthName: 'Nov', monthKey: '2022-11',
    sipInflowCr: 13306, netEquityInflowCr: 2258, netDebtInflowCr: 3683, netHybridInflowCr: 3120, totalIndustryAumLakhCr: 40.38, activeSipAccountsLakh: 605,
    categories: { smallCap: 450, midCap: 620, largeCap: 410, flexiCap: 520, sectoralThematic: 180, elss: 78, otherEquity: 0 }
  },
  {
    year: 2022, month: 12, monthName: 'Dec', monthKey: '2022-12',
    sipInflowCr: 13573, netEquityInflowCr: 7303, netDebtInflowCr: -21947, netHybridInflowCr: 2140, totalIndustryAumLakhCr: 39.89, activeSipAccountsLakh: 613,
    categories: { smallCap: 1240, midCap: 1560, largeCap: 1680, flexiCap: 1980, sectoralThematic: 540, elss: 303, otherEquity: 0 }
  },

  // ── 2023 (Mid & Small Cap Accumulation Ramp) ──
  {
    year: 2023, month: 1, monthName: 'Jan', monthKey: '2023-01',
    sipInflowCr: 13856, netEquityInflowCr: 12546, netDebtInflowCr: -10923, netHybridInflowCr: 4490, totalIndustryAumLakhCr: 39.62, activeSipAccountsLakh: 622,
    categories: { smallCap: 2250, midCap: 2840, largeCap: 3120, flexiCap: 3240, sectoralThematic: 780, elss: 316, otherEquity: 0 }
  },
  {
    year: 2023, month: 2, monthName: 'Feb', monthKey: '2023-02',
    sipInflowCr: 13686, netEquityInflowCr: 15686, netDebtInflowCr: -13815, netHybridInflowCr: 3210, totalIndustryAumLakhCr: 39.46, activeSipAccountsLakh: 628,
    categories: { smallCap: 2890, midCap: 3410, largeCap: 3890, flexiCap: 3980, sectoralThematic: 1040, elss: 476, otherEquity: 0 }
  },
  {
    year: 2023, month: 3, monthName: 'Mar', monthKey: '2023-03',
    sipInflowCr: 14276, netEquityInflowCr: 20534, netDebtInflowCr: -56884, netHybridInflowCr: 6890, totalIndustryAumLakhCr: 39.42, activeSipAccountsLakh: 636,
    categories: { smallCap: 3890, midCap: 4560, largeCap: 4980, flexiCap: 5210, sectoralThematic: 1240, elss: 654, otherEquity: 0 }
  },
  {
    year: 2023, month: 4, monthName: 'Apr', monthKey: '2023-04',
    sipInflowCr: 13728, netEquityInflowCr: 6480, netDebtInflowCr: 106677, netHybridInflowCr: 3410, totalIndustryAumLakhCr: 41.62, activeSipAccountsLakh: 642,
    categories: { smallCap: 1450, midCap: 1780, largeCap: 1240, flexiCap: 1450, sectoralThematic: 420, elss: 140, otherEquity: 0 }
  },
  {
    year: 2023, month: 5, monthName: 'May', monthKey: '2023-05',
    sipInflowCr: 14749, netEquityInflowCr: 3240, netDebtInflowCr: 45959, netHybridInflowCr: 6210, totalIndustryAumLakhCr: 43.20, activeSipAccountsLakh: 653,
    categories: { smallCap: 920, midCap: 1120, largeCap: 450, flexiCap: 520, sectoralThematic: 180, elss: 50, otherEquity: 0 }
  },
  {
    year: 2023, month: 6, monthName: 'Jun', monthKey: '2023-06',
    sipInflowCr: 14734, netEquityInflowCr: 8637, netDebtInflowCr: -14136, netHybridInflowCr: 4890, totalIndustryAumLakhCr: 44.39, activeSipAccountsLakh: 665,
    categories: { smallCap: 1840, midCap: 2150, largeCap: 1890, flexiCap: 2140, sectoralThematic: 420, elss: 197, otherEquity: 0 }
  },
  {
    year: 2023, month: 7, monthName: 'Jul', monthKey: '2023-07',
    sipInflowCr: 15245, netEquityInflowCr: 7626, netDebtInflowCr: 61440, netHybridInflowCr: 12470, totalIndustryAumLakhCr: 46.38, activeSipAccountsLakh: 681,
    categories: { smallCap: 1780, midCap: 2110, largeCap: 1450, flexiCap: 1680, sectoralThematic: 410, elss: 196, otherEquity: 0 }
  },
  {
    year: 2023, month: 8, monthName: 'Aug', monthKey: '2023-08',
    sipInflowCr: 15814, netEquityInflowCr: 20245, netDebtInflowCr: -25832, netHybridInflowCr: 17080, totalIndustryAumLakhCr: 46.63, activeSipAccountsLakh: 698,
    categories: { smallCap: 4260, midCap: 4890, largeCap: 3890, flexiCap: 5410, sectoralThematic: 1450, elss: 345, otherEquity: 0 }
  },
  {
    year: 2023, month: 9, monthName: 'Sep', monthKey: '2023-09',
    sipInflowCr: 16042, netEquityInflowCr: 14091, netDebtInflowCr: -101512, netHybridInflowCr: 18620, totalIndustryAumLakhCr: 46.58, activeSipAccountsLakh: 713,
    categories: { smallCap: 3120, midCap: 3890, largeCap: 2450, flexiCap: 3890, sectoralThematic: 520, elss: 221, otherEquity: 0 }
  },
  {
    year: 2023, month: 10, monthName: 'Oct', monthKey: '2023-10',
    sipInflowCr: 16928, netEquityInflowCr: 19932, netDebtInflowCr: 42634, netHybridInflowCr: 9910, totalIndustryAumLakhCr: 46.71, activeSipAccountsLakh: 730,
    categories: { smallCap: 4490, midCap: 5120, largeCap: 3240, flexiCap: 5410, sectoralThematic: 1340, elss: 332, otherEquity: 0 }
  },
  {
    year: 2023, month: 11, monthName: 'Nov', monthKey: '2023-11',
    sipInflowCr: 17073, netEquityInflowCr: 15536, netDebtInflowCr: -4707, netHybridInflowCr: 13540, totalIndustryAumLakhCr: 49.05, activeSipAccountsLakh: 744,
    categories: { smallCap: 3690, midCap: 4120, largeCap: 2450, flexiCap: 4120, sectoralThematic: 890, elss: 266, otherEquity: 0 }
  },
  {
    year: 2023, month: 12, monthName: 'Dec', monthKey: '2023-12',
    sipInflowCr: 17610, netEquityInflowCr: 16997, netDebtInflowCr: -75560, netHybridInflowCr: 15010, totalIndustryAumLakhCr: 50.78, activeSipAccountsLakh: 764,
    categories: { smallCap: 3850, midCap: 4210, largeCap: 2890, flexiCap: 4450, sectoralThematic: 1240, elss: 357, otherEquity: 0 }
  },

  // ── 2024 (Crosses ₹25k Cr Monthly SIP Milestone) ──
  {
    year: 2024, month: 1, monthName: 'Jan', monthKey: '2024-01',
    sipInflowCr: 18838, netEquityInflowCr: 21780, netDebtInflowCr: 76469, netHybridInflowCr: 20640, totalIndustryAumLakhCr: 52.74, activeSipAccountsLakh: 792,
    categories: { smallCap: 3257, midCap: 4056, largeCap: 1287, flexiCap: 4210, sectoralThematic: 6890, elss: 2080, otherEquity: 0 }
  },
  {
    year: 2024, month: 2, monthName: 'Feb', monthKey: '2024-02',
    sipInflowCr: 19187, netEquityInflowCr: 26866, netDebtInflowCr: 63809, netHybridInflowCr: 18105, totalIndustryAumLakhCr: 54.54, activeSipAccountsLakh: 820,
    categories: { smallCap: 2922, midCap: 3890, largeCap: 1943, flexiCap: 4890, sectoralThematic: 11263, elss: 1958, otherEquity: 0 }
  },
  {
    year: 2024, month: 3, monthName: 'Mar', monthKey: '2024-03',
    sipInflowCr: 19271, netEquityInflowCr: 22633, netDebtInflowCr: -198299, netHybridInflowCr: 18240, totalIndustryAumLakhCr: 53.40, activeSipAccountsLakh: 840,
    categories: { smallCap: -94, midCap: 1018, largeCap: 2128, flexiCap: 4120, sectoralThematic: 12340, elss: 3121, otherEquity: 0 }
  },
  {
    year: 2024, month: 4, monthName: 'Apr', monthKey: '2024-04',
    sipInflowCr: 20371, netEquityInflowCr: 18917, netDebtInflowCr: 189998, netHybridInflowCr: 19860, totalIndustryAumLakhCr: 57.26, activeSipAccountsLakh: 870,
    categories: { smallCap: 2209, midCap: 1793, largeCap: 357, flexiCap: 3890, sectoralThematic: 8940, elss: 1728, otherEquity: 0 }
  },
  {
    year: 2024, month: 5, monthName: 'May', monthKey: '2024-05',
    sipInflowCr: 20904, netEquityInflowCr: 34697, netDebtInflowCr: 42294, netHybridInflowCr: 17990, totalIndustryAumLakhCr: 58.91, activeSipAccountsLakh: 897,
    categories: { smallCap: 2724, midCap: 2521, largeCap: 663, flexiCap: 4560, sectoralThematic: 19213, elss: 5016, otherEquity: 0 }
  },
  {
    year: 2024, month: 6, monthName: 'Jun', monthKey: '2024-06',
    sipInflowCr: 21262, netEquityInflowCr: 40608, netDebtInflowCr: -107358, netHybridInflowCr: 8880, totalIndustryAumLakhCr: 61.16, activeSipAccountsLakh: 919,
    categories: { smallCap: 2263, midCap: 2528, largeCap: 970, flexiCap: 4890, sectoralThematic: 22352, elss: 7605, otherEquity: 0 }
  },
  {
    year: 2024, month: 7, monthName: 'Jul', monthKey: '2024-07',
    sipInflowCr: 23332, netEquityInflowCr: 37113, netDebtInflowCr: 119582, netHybridInflowCr: 17440, totalIndustryAumLakhCr: 64.97, activeSipAccountsLakh: 934,
    categories: { smallCap: 2109, midCap: 1799, largeCap: 670, flexiCap: 4120, sectoralThematic: 19798, elss: 8617, otherEquity: 0 }
  },
  {
    year: 2024, month: 8, monthName: 'Aug', monthKey: '2024-08',
    sipInflowCr: 23547, netEquityInflowCr: 38239, netDebtInflowCr: 45169, netHybridInflowCr: 10005, totalIndustryAumLakhCr: 66.70, activeSipAccountsLakh: 961,
    categories: { smallCap: 3209, midCap: 3054, largeCap: 2639, flexiCap: 5210, sectoralThematic: 18117, elss: 6010, otherEquity: 0 }
  },
  {
    year: 2024, month: 9, monthName: 'Sep', monthKey: '2024-09',
    sipInflowCr: 24508, netEquityInflowCr: 34419, netDebtInflowCr: -113834, netHybridInflowCr: 4901, totalIndustryAumLakhCr: 67.09, activeSipAccountsLakh: 988,
    categories: { smallCap: 3071, midCap: 3130, largeCap: 1769, flexiCap: 4890, sectoralThematic: 13259, elss: 8300, otherEquity: 0 }
  },
  {
    year: 2024, month: 10, monthName: 'Oct', monthKey: '2024-10',
    sipInflowCr: 25323, netEquityInflowCr: 41887, netDebtInflowCr: 157427, netHybridInflowCr: 16863, totalIndustryAumLakhCr: 67.25, activeSipAccountsLakh: 1012,
    categories: { smallCap: 3772, midCap: 4983, largeCap: 3499, flexiCap: 6120, sectoralThematic: 12279, elss: 11234, otherEquity: 0 }
  },
  {
    year: 2024, month: 11, monthName: 'Nov', monthKey: '2024-11',
    sipInflowCr: 26459, netEquityInflowCr: 39450, netDebtInflowCr: 24890, netHybridInflowCr: 14210, totalIndustryAumLakhCr: 68.50, activeSipAccountsLakh: 1038,
    categories: { smallCap: 3420, midCap: 4560, largeCap: 3120, flexiCap: 5890, sectoralThematic: 11450, elss: 11010, otherEquity: 0 }
  },
  {
    year: 2024, month: 12, monthName: 'Dec', monthKey: '2024-12',
    sipInflowCr: 26840, netEquityInflowCr: 42120, netDebtInflowCr: -64210, netHybridInflowCr: 16540, totalIndustryAumLakhCr: 70.10, activeSipAccountsLakh: 1060,
    categories: { smallCap: 3890, midCap: 4890, largeCap: 3560, flexiCap: 6450, sectoralThematic: 12100, elss: 11230, otherEquity: 0 }
  },

  // ── 2025 (Official AMFI Historical Flow) ──
  {
    year: 2025, month: 1, monthName: 'Jan', monthKey: '2025-01',
    sipInflowCr: 27250, netEquityInflowCr: 39669, netDebtInflowCr: 48900, netHybridInflowCr: 18210, totalIndustryAumLakhCr: 71.45, activeSipAccountsLakh: 1084,
    categories: { smallCap: 3890, midCap: 4890, largeCap: 3240, flexiCap: 6120, sectoralThematic: 11450, elss: 2120, otherEquity: 7949 }
  },
  {
    year: 2025, month: 2, monthName: 'Feb', monthKey: '2025-02',
    sipInflowCr: 27480, netEquityInflowCr: 29242, netDebtInflowCr: 12450, netHybridInflowCr: 15410, totalIndustryAumLakhCr: 72.10, activeSipAccountsLakh: 1102,
    categories: { smallCap: 2980, midCap: 3890, largeCap: 2450, flexiCap: 4890, sectoralThematic: 8940, elss: 1650, otherEquity: 4442 }
  },
  {
    year: 2025, month: 3, monthName: 'Mar', monthKey: '2025-03',
    sipInflowCr: 28120, netEquityInflowCr: 25017, netDebtInflowCr: -145210, netHybridInflowCr: 17240, totalIndustryAumLakhCr: 72.85, activeSipAccountsLakh: 1125,
    categories: { smallCap: 2450, midCap: 3120, largeCap: 2120, flexiCap: 4210, sectoralThematic: 7890, elss: 2890, otherEquity: 2337 }
  },
  {
    year: 2025, month: 4, monthName: 'Apr', monthKey: '2025-04',
    sipInflowCr: 28450, netEquityInflowCr: 24254, netDebtInflowCr: 84210, netHybridInflowCr: 19120, totalIndustryAumLakhCr: 74.20, activeSipAccountsLakh: 1148,
    categories: { smallCap: 2680, midCap: 3450, largeCap: 1890, flexiCap: 4120, sectoralThematic: 6940, elss: 1120, otherEquity: 4054 }
  },
  {
    year: 2025, month: 5, monthName: 'May', monthKey: '2025-05',
    sipInflowCr: 28910, netEquityInflowCr: 18995, netDebtInflowCr: 32150, netHybridInflowCr: 20410, totalIndustryAumLakhCr: 75.30, activeSipAccountsLakh: 1170,
    categories: { smallCap: 2120, midCap: 2890, largeCap: 1450, flexiCap: 3670, sectoralThematic: 5240, elss: 780, otherEquity: 2845 }
  },
  {
    year: 2025, month: 6, monthName: 'Jun', monthKey: '2025-06',
    sipInflowCr: 29140, netEquityInflowCr: 23568, netDebtInflowCr: -78900, netHybridInflowCr: 16890, totalIndustryAumLakhCr: 75.80, activeSipAccountsLakh: 1192,
    categories: { smallCap: 2540, midCap: 3240, largeCap: 1890, flexiCap: 4120, sectoralThematic: 6890, elss: 940, otherEquity: 3948 }
  },
  {
    year: 2025, month: 7, monthName: 'Jul', monthKey: '2025-07',
    sipInflowCr: 29560, netEquityInflowCr: 42673, netDebtInflowCr: 65420, netHybridInflowCr: 18940, totalIndustryAumLakhCr: 76.90, activeSipAccountsLakh: 1215,
    categories: { smallCap: 4560, midCap: 5670, largeCap: 3890, flexiCap: 6890, sectoralThematic: 12450, elss: 1450, otherEquity: 7763 }
  },
  {
    year: 2025, month: 8, monthName: 'Aug', monthKey: '2025-08',
    sipInflowCr: 29840, netEquityInflowCr: 38212, netDebtInflowCr: 24150, netHybridInflowCr: 17620, totalIndustryAumLakhCr: 77.40, activeSipAccountsLakh: 1238,
    categories: { smallCap: 3980, midCap: 4890, largeCap: 3240, flexiCap: 5980, sectoralThematic: 10890, elss: 1210, otherEquity: 8022 }
  },
  {
    year: 2025, month: 9, monthName: 'Sep', monthKey: '2025-09',
    sipInflowCr: 30120, netEquityInflowCr: 33430, netDebtInflowCr: -94500, netHybridInflowCr: 15410, totalIndustryAumLakhCr: 77.10, activeSipAccountsLakh: 1260,
    categories: { smallCap: 3450, midCap: 4210, largeCap: 2890, flexiCap: 5410, sectoralThematic: 9240, elss: 980, otherEquity: 7250 }
  },
  {
    year: 2025, month: 10, monthName: 'Oct', monthKey: '2025-10',
    sipInflowCr: 30450, netEquityInflowCr: 24690, netDebtInflowCr: 78900, netHybridInflowCr: 21450, totalIndustryAumLakhCr: 78.40, activeSipAccountsLakh: 1282,
    categories: { smallCap: 2680, midCap: 3450, largeCap: 2120, flexiCap: 4210, sectoralThematic: 6890, elss: 1120, otherEquity: 4220 }
  },
  {
    year: 2025, month: 11, monthName: 'Nov', monthKey: '2025-11',
    sipInflowCr: 30890, netEquityInflowCr: 29911, netDebtInflowCr: 18900, netHybridInflowCr: 19890, totalIndustryAumLakhCr: 79.10, activeSipAccountsLakh: 1305,
    categories: { smallCap: 3120, midCap: 3980, largeCap: 2450, flexiCap: 4890, sectoralThematic: 8450, elss: 1340, otherEquity: 5681 }
  },
  {
    year: 2025, month: 12, monthName: 'Dec', monthKey: '2025-12',
    sipInflowCr: 31000, netEquityInflowCr: 28054, netDebtInflowCr: -61200, netHybridInflowCr: 22150, totalIndustryAumLakhCr: 80.20, activeSipAccountsLakh: 1330,
    categories: { smallCap: 2890, midCap: 3670, largeCap: 2210, flexiCap: 4670, sectoralThematic: 7890, elss: 1450, otherEquity: 5274 }
  },

  // ── 2026 (Verified AMFI Official Releases) ──
  {
    year: 2026, month: 1, monthName: 'Jan', monthKey: '2026-01',
    sipInflowCr: 31002, netEquityInflowCr: 31450, netDebtInflowCr: 52400, netHybridInflowCr: 21900, totalIndustryAumLakhCr: 78.90, activeSipAccountsLakh: 1354,
    categories: { smallCap: 3890, midCap: 4560, largeCap: 2120, flexiCap: 4890, sectoralThematic: 7890, elss: 1240, otherEquity: 6850 }
  },
  {
    year: 2026, month: 2, monthName: 'Feb', monthKey: '2026-02',
    sipInflowCr: 29845, netEquityInflowCr: 28910, netDebtInflowCr: 14890, netHybridInflowCr: 19450, totalIndustryAumLakhCr: 79.40, activeSipAccountsLakh: 1378,
    categories: { smallCap: 3540, midCap: 4210, largeCap: 1890, flexiCap: 4560, sectoralThematic: 7120, elss: 1150, otherEquity: 6440 }
  },
  {
    year: 2026, month: 3, monthName: 'Mar', monthKey: '2026-03',
    sipInflowCr: 32087, netEquityInflowCr: 35120, netDebtInflowCr: -152400, netHybridInflowCr: 23150, totalIndustryAumLakhCr: 80.10, activeSipAccountsLakh: 1405,
    categories: { smallCap: 4210, midCap: 4890, largeCap: 2450, flexiCap: 5240, sectoralThematic: 8940, elss: 2140, otherEquity: 7250 }
  },
  {
    year: 2026, month: 4, monthName: 'Apr', monthKey: '2026-04',
    sipInflowCr: 31115, netEquityInflowCr: 32410, netDebtInflowCr: 89400, netHybridInflowCr: 22450, totalIndustryAumLakhCr: 80.90, activeSipAccountsLakh: 1430,
    categories: { smallCap: 3980, midCap: 4670, largeCap: 2210, flexiCap: 4980, sectoralThematic: 8120, elss: 1420, otherEquity: 7030 }
  },
  {
    year: 2026, month: 5, monthName: 'May', monthKey: '2026-05',
    sipInflowCr: 30954, netEquityInflowCr: 33890, netDebtInflowCr: 34100, netHybridInflowCr: 24100, totalIndustryAumLakhCr: 81.60, activeSipAccountsLakh: 1458,
    categories: { smallCap: 4120, midCap: 4890, largeCap: 2340, flexiCap: 5120, sectoralThematic: 8450, elss: 1560, otherEquity: 7410 }
  },
  {
    year: 2026, month: 6, monthName: 'Jun', monthKey: '2026-06',
    sipInflowCr: 31781, netEquityInflowCr: 34670, netDebtInflowCr: -81200, netHybridInflowCr: 20120, totalIndustryAumLakhCr: 82.20, activeSipAccountsLakh: 1482,
    categories: { smallCap: 4250, midCap: 5120, largeCap: 2450, flexiCap: 5340, sectoralThematic: 8690, elss: 1480, otherEquity: 7340 }
  },
  {
    year: 2026, month: 7, monthName: 'Jul', monthKey: '2026-07',
    sipInflowCr: 31961, netEquityInflowCr: 35410, netDebtInflowCr: 71200, netHybridInflowCr: 23890, totalIndustryAumLakhCr: 82.80, activeSipAccountsLakh: 1510,
    categories: { smallCap: 4420, midCap: 5280, largeCap: 2510, flexiCap: 5490, sectoralThematic: 8910, elss: 1520, otherEquity: 7280 }
  },
  {
    year: 2026, month: 8, monthName: 'Aug', monthKey: '2026-08',
    sipInflowCr: 32297, netEquityInflowCr: 29315, netDebtInflowCr: 45120, netHybridInflowCr: 12450, totalIndustryAumLakhCr: 83.20, activeSipAccountsLakh: 1535,
    categories: { smallCap: 3850, midCap: 4210, largeCap: 2120, flexiCap: 5120, sectoralThematic: 6890, elss: 420, otherEquity: 6705 }
  },
  {
    year: 2026, month: 9, monthName: 'Sep', monthKey: '2026-09',
    sipInflowCr: 32490, netEquityInflowCr: 38294, netDebtInflowCr: -133400, netHybridInflowCr: 10450, totalIndustryAumLakhCr: 82.64, activeSipAccountsLakh: 2862,
    categories: { smallCap: 9039, midCap: 7835, largeCap: 859, flexiCap: 6702, sectoralThematic: 3640, elss: -662, otherEquity: 10881 }
  },
];

/**
 * Recent Rolling Daily SEBI Mutual Fund Trading Activity (Equity & Debt)
 */
export const SEED_MF_DAILY_RECORDS: MfDailyItem[] = [
  { date: '2026-10-09', equityBuy: 18450.40, equitySell: 11210.15, equityNet: 7240.25, debtBuy: 14210.00, debtSell: 9810.00, debtNet: 4400.00, totalNet: 11640.25, diiEquityNet: 8940.10 },
  { date: '2026-10-08', equityBuy: 16890.10, equitySell: 12140.80, equityNet: 4749.30, debtBuy: 12450.00, debtSell: 10120.00, debtNet: 2330.00, totalNet: 7079.30, diiEquityNet: 5610.40 },
  { date: '2026-10-07', equityBuy: 17240.50, equitySell: 13580.20, equityNet: 3660.30, debtBuy: 15120.00, debtSell: 11450.00, debtNet: 3670.00, totalNet: 7330.30, diiEquityNet: 4320.15 },
  { date: '2026-10-06', equityBuy: 19120.80, equitySell: 14210.40, equityNet: 4910.40, debtBuy: 11890.00, debtSell: 10450.00, debtNet: 1440.00, totalNet: 6350.40, diiEquityNet: 6120.00 },
  { date: '2026-10-05', equityBuy: 20140.20, equitySell: 12890.50, equityNet: 7249.70, debtBuy: 13450.00, debtSell: 11200.00, debtNet: 2250.00, totalNet: 9499.70, diiEquityNet: 10041.84 },
  { date: '2026-10-04', equityBuy: 15420.10, equitySell: 13110.20, equityNet: 2309.90, debtBuy: 9840.00, debtSell: 8710.00, debtNet: 1130.00, totalNet: 3439.90, diiEquityNet: 3120.40 },
  { date: '2026-10-01', equityBuy: 18240.60, equitySell: 12940.30, equityNet: 5300.30, debtBuy: 16120.00, debtSell: 12400.00, debtNet: 3720.00, totalNet: 9020.30, diiEquityNet: 6740.10 },
  { date: '2026-09-30', equityBuy: 22450.90, equitySell: 16890.40, equityNet: 5560.50, debtBuy: 24150.00, debtSell: 19800.00, debtNet: 4350.00, totalNet: 9910.50, diiEquityNet: 7120.30 },
  { date: '2026-09-29', equityBuy: 19840.30, equitySell: 15420.10, equityNet: 4420.20, debtBuy: 14120.00, debtSell: 12150.00, debtNet: 1970.00, totalNet: 6390.20, diiEquityNet: 5610.00 },
  { date: '2026-09-26', equityBuy: 17210.50, equitySell: 14120.80, equityNet: 3089.70, debtBuy: 11450.00, debtSell: 9870.00, debtNet: 1580.00, totalNet: 4669.70, diiEquityNet: 4120.80 },
  { date: '2026-09-25', equityBuy: 21450.10, equitySell: 14890.40, equityNet: 6559.70, debtBuy: 13890.00, debtSell: 11200.00, debtNet: 2690.00, totalNet: 9249.70, diiEquityNet: 8240.20 },
  { date: '2026-09-24', equityBuy: 18940.60, equitySell: 13780.20, equityNet: 5160.40, debtBuy: 12450.00, debtSell: 10450.00, debtNet: 2000.00, totalNet: 7160.40, diiEquityNet: 6410.15 },
  { date: '2026-09-23', equityBuy: 16890.20, equitySell: 12450.10, equityNet: 4440.10, debtBuy: 11120.00, debtSell: 9450.00, debtNet: 1670.00, totalNet: 6110.10, diiEquityNet: 5320.00 },
  { date: '2026-09-22', equityBuy: 19450.80, equitySell: 15120.60, equityNet: 4330.20, debtBuy: 13240.00, debtSell: 11210.00, debtNet: 2030.00, totalNet: 6360.20, diiEquityNet: 5490.30 },
  { date: '2026-09-19', equityBuy: 24120.50, equitySell: 17450.20, equityNet: 6670.30, debtBuy: 15410.00, debtSell: 12890.00, debtNet: 2520.00, totalNet: 9190.30, diiEquityNet: 8420.50 },
  { date: '2026-09-18', equityBuy: 18450.10, equitySell: 14210.80, equityNet: 4239.30, debtBuy: 12100.00, debtSell: 10450.00, debtNet: 1650.00, totalNet: 5889.30, diiEquityNet: 5120.10 },
  { date: '2026-09-17', equityBuy: 17890.40, equitySell: 13650.20, equityNet: 4240.20, debtBuy: 11450.00, debtSell: 9890.00, debtNet: 1560.00, totalNet: 5800.20, diiEquityNet: 5210.40 },
  { date: '2026-09-16', equityBuy: 20120.90, equitySell: 14890.50, equityNet: 5230.40, debtBuy: 14120.00, debtSell: 11450.00, debtNet: 2670.00, totalNet: 7900.40, diiEquityNet: 6540.20 },
  { date: '2026-09-15', equityBuy: 16450.20, equitySell: 12980.10, equityNet: 3470.10, debtBuy: 10890.00, debtSell: 9450.00, debtNet: 1440.00, totalNet: 4910.10, diiEquityNet: 4120.00 },
  { date: '2026-09-12', equityBuy: 18240.50, equitySell: 13890.20, equityNet: 4350.30, debtBuy: 12450.00, debtSell: 10890.00, debtNet: 1560.00, totalNet: 5910.30, diiEquityNet: 5410.10 },
  { date: '2026-09-11', equityBuy: 19450.60, equitySell: 14210.40, equityNet: 5240.20, debtBuy: 13890.00, debtSell: 11450.00, debtNet: 2440.00, totalNet: 7680.20, diiEquityNet: 6450.30 },
  { date: '2026-09-10', equityBuy: 17120.30, equitySell: 13450.80, equityNet: 3669.50, debtBuy: 11200.00, debtSell: 9890.00, debtNet: 1310.00, totalNet: 4979.50, diiEquityNet: 4520.00 },
  { date: '2026-09-09', equityBuy: 22140.80, equitySell: 15670.20, equityNet: 6470.60, debtBuy: 15450.00, debtSell: 12100.00, debtNet: 3350.00, totalNet: 9820.60, diiEquityNet: 7890.40 },
  { date: '2026-09-08', equityBuy: 18450.20, equitySell: 13890.40, equityNet: 4559.80, debtBuy: 12450.00, debtSell: 10540.00, debtNet: 1910.00, totalNet: 6469.80, diiEquityNet: 5620.15 },
  { date: '2026-09-05', equityBuy: 16890.50, equitySell: 13240.10, equityNet: 3650.40, debtBuy: 11890.00, debtSell: 10120.00, debtNet: 1770.00, totalNet: 5420.40, diiEquityNet: 4410.20 },
  { date: '2026-09-04', equityBuy: 19120.10, equitySell: 14120.50, equityNet: 4999.60, debtBuy: 13450.00, debtSell: 11200.00, debtNet: 2250.00, totalNet: 7249.60, diiEquityNet: 6180.50 },
  { date: '2026-09-03', equityBuy: 21450.80, equitySell: 15890.20, equityNet: 5560.60, debtBuy: 14890.00, debtSell: 12450.00, debtNet: 2440.00, totalNet: 8000.60, diiEquityNet: 6920.00 },
  { date: '2026-09-02', equityBuy: 18450.30, equitySell: 13890.10, equityNet: 4560.20, debtBuy: 12100.00, debtSell: 10450.00, debtNet: 1650.00, totalNet: 6210.20, diiEquityNet: 5610.10 },
  { date: '2026-09-01', equityBuy: 23140.60, equitySell: 16890.40, equityNet: 6250.20, debtBuy: 16450.00, debtSell: 13200.00, debtNet: 3250.00, totalNet: 9500.20, diiEquityNet: 7890.25 },
];
